import React, { useEffect, useCallback } from 'react';

import ColumnsLayout from '../../../common/layout/ColumnsLayout';
import CurrencyInput from '../common/CurrencyInput';
import Uploader from '../../../common/Uploader';
import InputHelpLink from '../InputHelpLink';
import { getCurrencyOfCountry } from '../claimsHelpers';
import { Input } from '../../../common2/Input/Input';
import SidePanelContentSection from '../../../common2/side-panel/SidePanelContentSection';
import Column from '../../../common/layout/Column';
import useOnFormChange from '../../../../hooks/useOnFormChange';

function InvoiceForm(props) {
  const { claim, errors, onChange, onBusy, extractInvoiceData } = props;

  const onInputChange = useOnFormChange(onChange);

  const onInvoiceInputChange = useCallback(
    (value, name) => {
      if (value.length > 0) {
        const file = value[0];
        const fileId = Number(file?.response?.body?.id);
        extractInvoiceData && extractInvoiceData(fileId);
      }

      return onChange({ [name]: value });
    },
    [extractInvoiceData, onChange]
  );

  const uploaderHelpLinkElement = (
    <InputHelpLink to="https://support.portal.sevensenders.com/support/solutions/articles/15000048062-submission-document-requirements#Invoice-Requirements%C2%A0">
      Invoice requirements
    </InputHelpLink>
  );

  useEffect(() => {
    if (!claim.netValueCurrency) {
      onChange({ netValueCurrency: getCurrencyOfCountry(claim.carrierCountryCode) });
    }
  }, []);

  return (
    <Column spacing="medium">
      <SidePanelContentSection heading="Invoice information">
        <ColumnsLayout>
          <CurrencyInput
            amount={claim.netValue}
            currency={claim.netValueCurrency}
            amountName="netValue"
            currencyName="netValueCurrency"
            label="NET_VALUE_OF_INVOICE"
            onChange={onChange}
            error={errors.netValue}
            isRequired
            noErrorTranslation
          />
        </ColumnsLayout>
        <Uploader
          name="invoiceDocuments"
          files={claim.invoiceDocuments}
          label="Invoice document"
          topRightElement={uploaderHelpLinkElement}
          isRequired
          errorWithTranslation={errors.invoiceDocuments}
          allowedFileTypes={['application/pdf', 'image/jpg', 'image/jpeg', 'image/png']}
          helpText="CLAIMS_INVOICE_UPLOAD_HELP_TEXT"
          onChange={onInvoiceInputChange}
          onBusy={onBusy}
          maxNumberOfFiles={10}
        />
      </SidePanelContentSection>
      <SidePanelContentSection heading={'Additional information'}>
        <ColumnsLayout>
          <Input
            name="shopClaimId"
            label="Internal claim ID"
            placeholder="Add internal claim ID"
            value={claim.shopClaimId}
            error={errors.shopClaimId}
            onChange={onInputChange}
            noErrorTranslation
          />
        </ColumnsLayout>
      </SidePanelContentSection>
    </Column>
  );
}

export default React.memo(InvoiceForm);
